import { COLORS } from '../../../game/data/colors';

export const ProgressBar: React.FC<{ fill: number; height: number; containerStyle?: React.CSSProperties }> = ({
  fill,
  height,
  containerStyle,
}) => {
  return (
    <div
      style={{
        width: '100%',
        height: height,
        backgroundColor: COLORS.gray_200,
        borderRadius: height / 2,
        overflow: 'hidden',
        ...containerStyle,
      }}
    >
      <div
        style={{
          width: `${fill * 100}%`,
          height: '100%',
          backgroundColor: COLORS.green_500,
          borderRadius: height / 2,
        }}
      ></div>
    </div>
  );
};
